// extracted by mini-css-extract-plugin
export var locationCard = "_hm-0";